import React from 'react';

const NotCurrPageRec = () => {
    const  grayRectangleStyle= {
        width: '90px',
        height: '5px',
        backgroundColor: 'var(--primary-color-lt)',
        borderRadius: '5px',
    };

    return(
        <div style={grayRectangleStyle}/>
    );
};

export default NotCurrPageRec;